import React from "react"
import { Redirect, Switch } from "react-router-dom"
import { useSelector, shallowEqual } from "react-redux"
import { ContentRoute } from "../../layout"
import { InventoryPage } from "./inventory/InventoryPage"
import { MapInfrastructurePage } from "./map-infrastructure/MapInfrastructurePage"
import { Header } from "../../_partials/widgets/Header"

const IMVENTORY_TITLE = "Inventory"
const INVENTORY_HEADER_ICON_SRC = "/media/svg/icons/General/NotebookWithPen.svg"

export default function OperationsPage() {
	const { userClaims } = useSelector(
		state => ({
			userClaims: state.auth.claims
		}),
		shallowEqual
	)

	return (
		<div data-testid="operationsPage">
			<Header iconSrc={INVENTORY_HEADER_ICON_SRC} title={IMVENTORY_TITLE} />
			<Switch>
				<Redirect exact={true} from="/operations" to="/operations/inventory" />

				{userClaims?.isSuper && (
					<ContentRoute from="/operations/inventory" component={InventoryPage} />
				)}

				{userClaims?.isSuper && (
					<ContentRoute
						from="/operations/manage-infrastructure"
						component={MapInfrastructurePage}
					/>
				)}
			</Switch>
		</div>
	)
}
